/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { IdentifiedCompanyResponse } from './';
import {
    IdentifiedCompanyResponseFromJSON,
    IdentifiedCompanyResponseFromJSONTyped,
    IdentifiedCompanyResponseToJSON,
} from './';
import type { ResultQualityResponse } from './';
import {
    ResultQualityResponseFromJSON,
    ResultQualityResponseFromJSONTyped,
    ResultQualityResponseToJSON,
} from './';
import type { SearchModeResponse } from './';
import {
    SearchModeResponseFromJSON,
    SearchModeResponseFromJSONTyped,
    SearchModeResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientSuggestionResponse
 */
export interface ClientSuggestionResponse {
    /**
     * 
     * @type {IdentifiedCompanyResponse}
     * @memberof ClientSuggestionResponse
     */
    clientCompany?: IdentifiedCompanyResponse;
    /**
     * 
     * @type {SearchModeResponse}
     * @memberof ClientSuggestionResponse
     */
    searchMode: SearchModeResponse;
    /**
     * 
     * @type {ResultQualityResponse}
     * @memberof ClientSuggestionResponse
     */
    resultQuality: ResultQualityResponse;
}

/**
 * Check if a given object implements the ClientSuggestionResponse interface.
 */
export function instanceOfClientSuggestionResponse(value: object): value is ClientSuggestionResponse {
    if (!('searchMode' in value) || value['searchMode'] === undefined) return false;
    if (!('resultQuality' in value) || value['resultQuality'] === undefined) return false;
    return true;
}

export function ClientSuggestionResponseFromJSON(json: any): ClientSuggestionResponse {
    return ClientSuggestionResponseFromJSONTyped(json, false);
}

export function ClientSuggestionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientSuggestionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientCompany': json['clientCompany'] == null ? undefined : IdentifiedCompanyResponseFromJSON(json['clientCompany']),
        'searchMode': SearchModeResponseFromJSON(json['searchMode']),
        'resultQuality': ResultQualityResponseFromJSON(json['resultQuality']),
    };
}

export function ClientSuggestionResponseToJSON(value?: ClientSuggestionResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clientCompany': IdentifiedCompanyResponseToJSON(value['clientCompany']),
        'searchMode': SearchModeResponseToJSON(value['searchMode']),
        'resultQuality': ResultQualityResponseToJSON(value['resultQuality']),
    };
}

